exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".topbar{height:50px;position:absolute;left:0;top:0;width:100%;padding-left:60px;background:linear-gradient(270deg,#2ba3cf,#22b6b4)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4f49d903!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigation/Topbar.vue
// module id = 468
// module chunks = 22